<script setup>
/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- demo content uses a fixed translation-key catalog. */
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import InboxCard from 'dashboard/components-next/lumerai/assistant/InboxCard.vue';
import { inboxes } from 'dashboard/components-next/lumerai/pageComponents/emptyStates/lumeraiEmptyStateContent.js';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <EmptyStateLayout
    :title="$t('LUMERAI.INBOXES.EMPTY_STATE.TITLE')"
    :subtitle="$t('LUMERAI.INBOXES.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <InboxCard
          v-for="(inbox, index) in inboxes.slice(0, 5)"
          :id="inbox.id"
          :key="`inbox-${index}`"
          :inbox="{ ...inbox, name: $t(inbox.nameKey) }"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('LUMERAI.INBOXES.ADD_NEW')"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
